import {
  EledoChangeColorField,
  EledoCheckboxField,
  EledoColorField,
  EledoDocumentFormatSelect,
  EledoFileField,
  EledoNumberField,
  EledoPasswordField,
  EledoRadioButtonField,
  EledoSelect,
  EledoStyledColorField,
  EledoSubmitField,
  EledoTextArea,
  EledoTextField,
  formFieldName
} from "./EledoFormsComponents";
import React, { Children, useEffect, useState } from "react";
import {FormFieldTypes} from "model/enums";
import {EledoExpressionFieldNew, EledoLoader} from "components/library";
import { useFormContext } from "react-hook-form";

const _ = require('lodash');

/**
 * Example of use can be found in `template/EledoSettings` component.
 * Do not use without FormProvider and an enclosing form tag.
 */
const EledoFormGenerator = ({formModel, editedDataObject, forChange = false, ...props}) => {
  const {fields, validation} = formModel;

  return (
    <React.Fragment>
      {!editedDataObject && <div style={{padding: "2rem 0", display: "flex", justifyContent: "center"}}><EledoLoader/></div>}
      {editedDataObject && fields.map(f => {
        const fieldValidation = validation[f.id] ? validation[f.id] : {};
        const id = formFieldName(f.id, f.path)
        if(!forChange){
          return renderField(f, fieldValidation, editedDataObject, null, props);
        } else {
          return (<>
            <ForEditWrapper key={id} id={id} label={f.label}>
              <>
                { renderField(f, fieldValidation, editedDataObject, null, props) }
              </>
            </ForEditWrapper>
          </>)
        }
      })}
    </React.Fragment>
  );
};

const getDefaultValue = (editedDataObject, field) => {
  return _.get(editedDataObject, field.path ? `${field.path}.${field.id}` : field.id);
}

const renderField = (field, validation, editedDataObject, onChangeHandler, props) => {
  const fieldProps = {
    id: field.id,
    label: field.label,
    path: field.path,
    level: field.level ? field.level : 0,
    required: field.required ? field.required : false,
    validation: validation,
    defaultValue: getDefaultValue(editedDataObject, field)
  }
  switch(field.type) {
    case FormFieldTypes.SHORT_STRING: return <EledoTextField key={field.id} {...fieldProps}/>;
    case FormFieldTypes.LONG_STRING: return <EledoTextArea key={field.id} {...fieldProps}/>;
    case FormFieldTypes.NUMBER: return <EledoNumberField  key={field.id} {...fieldProps}/>;
    case FormFieldTypes.SELECT: return <EledoSelect key={field.id} {...fieldProps} options={field.options}/>;
    case FormFieldTypes.EXPRESSION: return <EledoExpressionFieldNew dataModel={props.dataModel} key={field.id} {...fieldProps}/>;
    case FormFieldTypes.PASSWORD: return <EledoPasswordField key={field.id} {...fieldProps}/>;
    case FormFieldTypes.CHECKBOX: return <EledoCheckboxField key={field.id} {...fieldProps}/>
    case FormFieldTypes.RADIO: return <EledoRadioButtonField groupName={field.groupName} key={field.id} {...fieldProps}/>;
    case FormFieldTypes.DOCUMENT_FORMAT_SELECT: return <EledoDocumentFormatSelect key={field.id} {...fieldProps}/>
    case FormFieldTypes.FILE: return <EledoFileField key={field.id} {...fieldProps}/>;
    case FormFieldTypes.COLOR: return <EledoColorField key={field.id} {...fieldProps}/>;
    case FormFieldTypes.STYLED_COLOR: return <EledoStyledColorField key={field.id} {...fieldProps}/>;
    case FormFieldTypes.CHANGE_COLOR: return <EledoChangeColorField key={field.id} {...fieldProps}/>;
    case FormFieldTypes.SUBMIT: return <EledoSubmitField key={field.id} {...fieldProps}/>;
    case FormFieldTypes.CUSTOM:
      return field?.renderField && field.renderField(validation, onChangeHandler);
    default: return null;
  }
};

const ForEditWrapper = ({id, label, children}) => {
  const [change, setChange] = useState(false)
  const formHandler = useFormContext();

  useEffect(() => {
    if(change){
      formHandler.setValue(id, null)
    } else {
      formHandler.setValue(id, null)
    }
  }, [change])

  return (<>
    <div>
      <input type="checkbox" value={change} onChange={(event) => {setChange(event.currentTarget.checked)}}
        style={{marginRight: '0.5em'}}/>
      <span>Change {label}</span>
    </div>
        { change === true &&
          <>
            {children}
          </>
        }
  </>)
}

export default EledoFormGenerator;